import { createContext, useContext } from 'react';

const CardContext = createContext({
    image: undefined,
    imagePosition: "top",
});
const useCardContext = () => useContext(CardContext);

export { CardContext, useCardContext };
